/**
 * Format a policy's effective date ("Policy As Of") for display.
 *
 * The analysis agent returns this date in varied formats — ISO ("2025-04-07"),
 * month-name ("Oct-17-2025", "April 7, 2025"), etc. We render an ISO value in
 * the same "Apr 7, 2025" style as the "Analyzed on" date (parsed as a LOCAL
 * date to avoid the UTC off-by-one), and pass any other format through verbatim
 * so we never mangle what the agent reported.
 *
 * Returns null for empty/missing input so callers can hide the field entirely.
 */
export function formatPolicyDate(value) {
  if (!value) return null;
  const raw = String(value).trim();
  if (!raw) return null;

  const iso = /^(\d{4})-(\d{2})-(\d{2})$/.exec(raw);
  if (iso) {
    const d = new Date(Number(iso[1]), Number(iso[2]) - 1, Number(iso[3]));
    if (!Number.isNaN(d.getTime())) {
      return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
    }
  }
  return raw;
}
